import gql from "graphql-tag";

export const GET_INDUSTRY_CATEGORIES = gql`
  query CompanyCategories {
    companyCategories {
      isSuccessful
      message
      companyCategories {
        companyId
        hasRelation
        srcColumn
        text
        srcTable
      }
    }
  }
`

export const UPDATE_INDUSTRY_CATEGORIES = gql`
  mutation UpdateCompanyCategory($input: UpdateLookupInputSimple!) {
    updateCompanyCategory(input: $input) {
      isSuccessful
      message
      companyCategory {
        companyId
        hasRelation
        srcColumn
        text
        srcTable
      }
    }
  }
`

export const DELETE_INDUSTRY_CATEGORIES = gql`
  mutation DeleteCompanyCategory($input: DeleteLookupInputSimple!) {
    deleteCompanyCategory(input: $input) {
      isSuccessful
      message
      companyCategory {
        srcTable
        text
        srcColumn
        hasRelation
        companyId
      }
    }
  }
`

export const CREATE_INDUSTRY_CATEGORIES = gql`
  mutation CreateCompanyCategory($input: CreateLookupInputSimple!) {
    createCompanyCategory(input: $input) {
      isSuccessful
      message
      companyCategory {
        companyId
        hasRelation
        srcColumn
        srcTable
        text
      }
    }
  }
`